import client from '@/api/base';

export default {
  // CVC API
  async getEngagementCvcSurvey(id) {
    const response = await client.get(`/coaching/engagement/${id}/cvc/survey/`);
    return response;
  },

  async publishEngagementCvcSurvey(id, data) {
    const response = await client.post(`/coaching/engagement/${id}/cvc/survey/`, data);
    return response;
  },

  async getEngagementCvcReport(id) {
    const response = await client.get(`/coaching/coach/engagement/${id}/cvc/report/`);
    return response;
  },
};
